import { APP_CONFIG } from 'services/app-config'

export const CONFIG = {
  api: {
    changeTechnology: `${APP_CONFIG.care_cluster}/ms-ct-ca/change-service`,
    logBackOfficeInfo: `${APP_CONFIG.logs_host}/log-back-office-info`,
  },
}
